import React, { useMemo } from 'react';
import { ReduxControls, Icon } from '@flashtalking/rhombus-react';
import { Field, FieldArray } from 'redux-form';
import { minValue, isInteger } from 'widgets/forms/validators/validators';
import { ADD_ADSTUDIO_TO_CONCEPT_FORM,  ADD_CREATIVE_TAGS_TO_CONCEPT_FORM } from 'widgets/forms/list';

import './CustomSizes.css';

function renderCustomFields(obj){
	const { name } = obj.input
		, { disabled, formErrors = {} } = obj
		, { customErrors = {} } = formErrors;

	let hasAnError = customErrors[name]?.width && customErrors[name]?.height;

	return (
		<div key={name} className="dimensions-row">
			<Field name={`${name}.width`}
				className="number-input"
				component={ReduxControls.Input}
				placeholder="Width"
				hasError={!!hasAnError}
				validate={[minValue, isInteger]}
				disabled={disabled}
				 />
			<Field name={`${name}.height`}
				className="number-input"
				component={ReduxControls.Input}
				placeholder="Height"
				hasError={!!hasAnError}
				validate={[minValue, isInteger]}
				disabled={disabled}
				 />
		</div>
	);
}

function renderCustomSizes({ fields, errors, isEdit, customSizes, initialValues, modalName }){
	const isDisabled = useMemo(() => (
		[ADD_ADSTUDIO_TO_CONCEPT_FORM, ADD_CREATIVE_TAGS_TO_CONCEPT_FORM].includes(modalName)
	), [modalName]);

	const handleClick = () => {
		fields.push({});
	};

	let $icon = null;

	const disableDeleteIcon = (index) => {
		if(!isEdit && isDisabled){
			if(!initialValues['custom-sizes'].includes(customSizes[index])) {
				 $icon = <Icon name="far fa-times-circle" onClick={() => fields.remove(index)} />;
			}
		}
		return $icon;
	};

	return (
		<ul className="custom-sizes">
			{fields.map((key, index, fields) => {
				return (
					<li key={key} className="field">
						<Field component={renderCustomFields} disabled={isDisabled ? !disableDeleteIcon(index) : false} formErrors={errors} name={key} />
						{disableDeleteIcon(index)}
						{modalName === 'open-concept' ? <Icon name="far fa-times-circle" onClick={() => fields.remove(index)} /> : null}
					</li>
				);
			})}
			<a className="add-field" onClick={handleClick}>
				Add Custom Size
			</a>
		</ul>
	);
}

export default function CustomSizes(props){
	const { customSizes, errorMessages } = props;
	return (
		<React.Fragment>
			<label className={customSizes && errorMessages.length ? 'error-label' : ''}>Custom Placement Sizes</label>
			<FieldArray component={renderCustomSizes} props={props} name="custom-sizes" />
		</React.Fragment>
	);
}
CustomSizes.displayName = "CustomSizes";
